<template>
  <div class="double11-wrap">
    <app-header />
    <div class="auto1200">
      <div class="slogen">
        <p class="time"><span>活动时间：11.01-11.11</span></p>
        <div class="tag">AI资金策略、机构热股、ACE资金、热点轮动、股知道、DDE决策、大数据掘金、董秘爆料、智能复盘统计</div>
        <div class="title"></div>
      </div>
      <div class="discountList">
        <div class="item" v-for="product in productList" :key="product.key">
          <h3>{{product.name}}</h3>
          <p class="detail" v-show="product.detail">({{product.detail}})</p>
          <p class="curPrice">活动价<span><em>￥</em>{{product.curPrice}}</span></p>
          <del class="oldPrice" v-show="product.oldPrice">原价<span><em>￥</em>{{product.oldPrice}}</span></del>
          <span class="button" @click="goUrl(product.key)"><em>立即购买</em></span>
        </div>
      </div>
      <div class="send-box">
        <div class="text">双11活动期间(11月1日至11月11日)，购买（策略终端+18款APP功能产品）钜惠大礼包
或大智慧策略终端年卡的用户，可享以下五大福利。</div>
        <div class="con">
          <div class="item" v-for="item in sendList" :key="item.key">
            <h3>{{item.name}}</h3>
            <p>{{item.detail}}</p>
          </div>
        </div>
      </div>
      <div class="content">
        <h3><span>AI资金抢筹系统</span></h3>
        <div class="img-box">
          <div class="img">
            <img src="@/assets/images/activity/double11/2/img1.png" alt="">
          </div>
        </div>
        <h3><span>ACE决策系统</span></h3>
        <div class="img-box">
          <div class="img">
            <img src="@/assets/images/activity/double11/2/img2.png" alt="">
          </div>
        </div>
        <h3><span>机构热股，让机构帮你挖掘投资主线</span></h3>
        <div class="img-box">
          <div class="img">
            <img src="@/assets/images/activity/double11/2/img3.png" alt="">
          </div>
        </div>
        <h3><span>股知道，价值投资利器</span></h3>
        <div class="img-box">
          <div class="img">
            <img src="@/assets/images/activity/double11/2/img4.png" alt="">
          </div>
        </div>
        <h3><span>热点轮动，智能捕捉短线热门概念题材及龙头股的脉络</span></h3>
        <div class="img-box">
          <div class="img">
            <img src="@/assets/images/activity/double11/2/img5.png" alt="">
          </div>
        </div>t
      </div>
      <div class="giftBox">
        <div class="text">
          <p>活动期间购买大礼包（价值60361元）即可获得以下权限：</p>
          <p>1、PC端：《大智慧策略投资终端》1年，价值38000元；</p>
          <p>2、APP端：18款功能产品1年，价值22361元。详见列表</p>
        </div>
        <div class="con">
          <ul class="list">
            <li v-for="(item, index) in giftList" :key="index">
              <div>
                <span>{{item.name}}</span>
                <em>{{item.money}}</em>
              </div>
            </li>
          </ul>
          <div class="price">
            <p>现优惠价只要：</p>
            <span><em>9800</em><i>元/年</i></span>
          </div>
        </div>
      </div>
      <div class="note">
        <p><em>温馨提示：</em><span>买一享五活动仅限大智慧策略投资终端、钜惠大礼包(策略投资终端+APP端18款功能)用户。</span></p>
        <p>案例仅用于客观数据展示，不构成投资建议，据此操作风险自担。</p>
      </div>
    </div>
  </div>
</template>
<script>
import AppHeader from "@/components/common/AppHeader.vue";
export default {
  data() {
    return {
      productList: [
        {
          key: 3028,
          name: '钜惠大礼包',
          detail: '大智慧策略投资终端年卡+APP端18款产品',
          curPrice: 47800,
          oldPrice: 60361
        },
        {
          key: 113,
          name: '策略投资终端',
          curPrice: 38000,
        }
      ],
      sendList: [
        {
          key: 1,
          name: '移动端用户等级直升皇冠',
          detail: '参与20周年庆抽奖活动，飞天茅台、智能小家电等你来拿'
        },
        {
          key: 2,
          name: '3800慧豆',
          detail: '可用于参与APP慧信特训班、赢大奖、观摩高手交易技巧'
        },
        {
          key: 3,
          name: '2021年《热门行业季度报告》（4份）',
          detail: '精选一线热点，捕捉下一个市场“风口”'
        },
        {
          key: 4,
          name: '软件技术导师1V1指导（全年）',
          detail: '资深软件技术导师贴身指导，应用技巧倾囊相授'
        },
        {
          key: 5,
          name: 'AI战法视频课程（一套）',
          detail: '精品好课！深度拆解资金背后的逻辑和实战用法'
        }
      ],
      giftList: [
        {
          name: '产品名称',
          money: '原价（元/年）'
        },
        {
          name: '云梯通道',
          money: '339'
        },
        {
          name: '双突战法',
          money: '88'
        },
        {
          name: '神奇D信号',
          money: '88'
        },
        {
          name: '九转交易',
          money: '1099'
        },
        {
          name: '主力筹码追踪',
          money: '888'
        },
        {
          name: '优选大师',
          money: '9800'
        },
        {
          name: '波段王',
          money: '799'
        },
        {
          name: '白马智投',
          money: '1699'
        },
        {
          name: '港股level-2',
          money: '68'
        },
        {
          name: '追击反转',
          money: '618'
        },
        {
          name: '尾盘动能',
          money: '848'
        },
        {
          name: '资金搏击',
          money: '818'
        },
        {
          name: '题材王',
          money: '1598'
        },
        {
          name: '异动查',
          money: '299'
        },
        {
          name: '情绪转点',
          money: '698'
        },
        {
          name: '机构热股',
          money: '1099'
        },
        {
          name: '抢筹先锋',
          money: '898'
        },
        {
          name: '分时顶底',
          money: '898'
        },
         {
          name: '合计：',
          money: '22361'
        }
      ]
    }
  },
  created() {
    var token = this.$route.query.token;
    if (token) {
      this.token = token;
    }
  },
  methods: {
    goUrl (key, month=12) {
      let routerDate;
      if (key === 3028) {
        routerDate = this.$router.resolve({name: 'OrderConfirm', params:{productId: key, month: month}})
      }
      else if (this.token && key !== 3028) {
        routerDate = this.$router.resolve({name: 'ClientProduct', query: {token: this.token, pid: key}})
      } else {
        routerDate = this.$router.resolve({name: 'OrderConfirm', params:{productId: key, month: month}})
      }
      let {href} = routerDate
      window.open(href, "_blank")
    }
  },
  components: {
    AppHeader,
  }
}
</script>

<style lang="scss" scoped>
.double11-wrap{
  background: url(../../assets/images/activity/double11/2/bg1.jpg) no-repeat center 100px,
  url(../../assets/images/activity/double11/2/bg2.jpg) no-repeat center 900px,
  url(../../assets/images/activity/double11/2/bg3.jpg) no-repeat center 1900px,
  url(../../assets/images/activity/double11/2/bg4.jpg) no-repeat center 2900px,
  url(../../assets/images/activity/double11/2/bg5.jpg) no-repeat center 3900px,
  url(../../assets/images/activity/double11/2/bg6.jpg) no-repeat center 4900px,
  url(../../assets/images/activity/double11/2/bg7.jpg) no-repeat center 5900px,
  url(../../assets/images/activity/double11/2/bg8.jpg) no-repeat center 6900px #2a1a41;
  .auto1200{width: 1200px;margin: 0 auto;}
  .slogen{
    padding-top: 500px;
    .time{
      text-align: center;
      >span{
        border: 2px solid #f62869;
        display: inline-block;
        border-radius: 30px;
        font-size: 24px;
        color: #f62869;
        padding: 5px 15px;
      }
    }
    .tag{
      background: url(../../assets/images/activity/double11/2/tag-bg.png) no-repeat;
      width: 1200px;
      height: 58px;
      font-size: 22px;
      color: #ffe793;
      line-height: 46px;
      text-align: center;
      margin: 20px 0 38px;
    }
    .title{
      background: url(../../assets/images/activity/double11/2/slogen.png) no-repeat;
      @include wh(520px, 105px);
      margin: 0 auto;
    }
  }
  .discountList{
    margin: 30px 0 30px;
    padding-bottom: 20px;
    overflow: hidden;
    .item{
      padding: 65px 0 0px;
      @include wh(570px, 443px);
      background: url(../../assets/images/activity/double11/2/product-bg.png) no-repeat;
      text-align: center;
      float: left;
      position: relative;
      box-sizing: border-box;
      +.item{
        margin-left: 55px;
      }
      h3{
        font-size: 60px;
        color: #fff;
        line-height: 1;
      }
      >p{
        line-height: 1;
        em{
          margin: 0 8px;
        }
      }
      .detail{
        font-size: 24px;
        color: #fff;
        margin-top: 10px;
      }
      .curPrice{
        font-size: 36px;
        color: #f4d49f;
        margin: 45px 0 20px;
        position: absolute;
        bottom: 190px;
        left: 0%;
        right: 0;
        text-align: center;
      }
      .oldPrice{
        font-size: 30px;
        color: #e44a65;
        position: absolute;
        bottom: 159px;
        left: 0%;
        right: 0;
        text-align: center;
      }
      .button{
        background-image: linear-gradient(to bottom, #ffee8f, #ffab50);
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffee8f', endColorstr='#ffab50',GradientType=0 ); // ie9
        width: 330px;
        border-radius: 40px;
        @include fc(42px, #5f0f12);
        cursor: pointer;
        display: table;
        height: 68px;
        position: absolute;
        bottom: 35px;
        left: 50%;
        margin-left: -165px;
        >em{
          display: table-cell;
          vertical-align: middle;
        }
      }
    }
  }
  .send-box{
    .text{
      font-size: 30px;
      color: #fbe2bf;
      line-height: 38px;
      padding-left: 60px;
      background: url(../../assets/images/activity/double11/2/star.png) no-repeat 0 0px;
      margin-bottom: 35px;
    }
    .con{
      width: 1200px;
      box-sizing: border-box;
      border: 4px solid #ffe8ce;
      background:#b82544;
      padding: 40px 60px 48px 80px;
      overflow: hidden;
      position: relative;
      border-radius: 10px;
      &:after{
        content:  '';
        display: block;
        @include wh(752px, 177px);
        background: url(../../assets/images/activity/double11/2/send-bg.png) no-repeat;
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: 2;
      }
      .item{
        padding-bottom: 35px;
        float: left;
        border-bottom: 2px solid #981f38;
        box-sizing: border-box;
        &:nth-child(odd){
          border-right: 2px solid #981f38;
          width: 49%;
        }
        &:nth-child(even){
          width: 51%;
          padding-left: 80px;
        }
        &:nth-child(n+3){
          padding-top: 40px;
        }
        &:last-child{
          padding-bottom: 0;
          border-bottom: 0;
        }
        h3{
          @include fc(30px, #fff);
          position: relative;
          &:before{
            content: '';
            display: block;
            @include wh(50px, 50px);
            background: url(../../assets/images/activity/double11/2/send.png) no-repeat;
            position: absolute;
            left: -55px;
            top: -5px;
          }
        }
        p{
          @include fc(18px, #f4d49f);
          margin-top: 10px;
        }
      }
    }
  }
  .content{
    h3{
      text-align: center;
      font-size: 36px;
      color: #fff;
      position: relative;
      margin: 35px auto;
      &:before{
        content: '';
        display: block;
        @include wh(100%, 1px);
        border-bottom: 2px dashed #c87999;
        position: absolute;
        left: 0;
        top: 50%;
        z-index: 0;
      }
      >span{
        @include fc(36px, #fff);
        display: inline-block;
        padding: 0 35px;
        margin: 0 auto;
        position: relative;
        z-index: 2;
        background: #2a1a41;
      }
    }
    .img-box{
      background: #7e2c52;
      border: 4px solid #c87999;
      padding: 30px;
      margin: 40px 0;
      border-radius: 10px;
    }
    .img{
      img{
        display: block;
        margin: 0 auto;
     }
    }
  }
  .giftBox{
    .text{
      background: url(../../assets/images/activity/double11/2/star.png) no-repeat;
      padding-left: 70px;
      margin-bottom: 30px;
      p{
        @include fc(30px, #fbe2bf);
        margin-bottom: 5px;
      }
    }
    .con{
      background: url(../../assets/images/activity/double11/2/gift-bg.png) no-repeat;
      padding: 100px 0 70px 40px;
      height: 1131px;
      position: relative;
      box-sizing: border-box;
      >.list{
        background: #4e1f78;
        width: 600px;
        border-radius: 10px;
        li{
          height: 46px;
          line-height: 46px;
          overflow: hidden;
          @include fc(24px, #fff);
          padding: 0 56px;
          &:nth-child(1),&:last-child, &:nth-last-child(2){
            >div{
              border-bottom: 0;
            }
          }
          >div{
            border-bottom: 1px solid #814aaf;
            height: 45px;

          }
          span{
            float: left;
          }
          em{
            float: right;
          }
          &:nth-child(1){
            background: #eb5270;
            border-radius: 10px 10px 0 0;
          }
          &:last-child{
            background: #ac3e73;
            color: #fbbbab;
            border-radius: 0 0 10px 10px;
          }
        }
      }
      .price{
        position: absolute;
        top: 220px;
        left: 750px;
        p{
          @include fc(60px, #f9ddb4);
          margin-bottom: 30px;
        }
        >span{
          display: block;
          background-image: linear-gradient(to right, #ffe8ce, #f4d49f);
          filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffe8ce', endColorstr='#f4d49f',GradientType=0 ); // ie9
          box-shadow: 0 7px 10px rgba($color: #6b163d, $alpha: 0.5);
          @include wh(385px, 167px);
          @include fc(36px, #b82544);
          line-height: 167px;
          border-radius: 20px;
          text-align: center;
          em{
            @include fc(80px, #b82544);
            margin-right: 5px;
          }
          i{
            vertical-align: top;
          }
        }
      }
    }
  }
  .note{
    padding:50px 40px 70px;
    p{
      font-size: 30px;
      color: #a2a2a2;
      line-height: 48px;
      margin-bottom: 5px;
      >em{
        float: left;
        height: 60px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/DoubelEleven2.vue